import React from "react";
import DocumentExplorer from "../../../components/documentLibrary/DocumentExplorer";

const Home = () => {
  return (
    <DocumentExplorer />
  );
};

export default Home;
